import { queryClient } from "./client";

export function invalidateBinderWatchlistVariantsQueries() {
  queryClient.invalidateQueries({
    queryKey: ["binders"],
  });
  queryClient.invalidateQueries({ queryKey: ["binder"] });
  queryClient.invalidateQueries({ queryKey: ["card", "variants"] });
  queryClient.invalidateQueries({
    queryKey: ["watchlist"],
  });
  queryClient.invalidateQueries({
    queryKey: ["watchlist-variants"],
  });
}
